import { Message } from '@/type/chat';
import { useState } from 'react';
import { LikedIcon, LikeIcon, UnlikedIcon, UnlikeIcon } from '../Icons/Icons';
import customFetch from '@/lib/utils/fetch';
import { usePathname } from 'next/navigation';
import { MessageFeedbackDialog } from '../feedback';
import useSWR from 'swr';

const Like = ({ message }: { message: Message }) => {
  const { data: userInfo } = useSWR('currentUserInfo');
  const [loading, setLoading] = useState(false);
  const [messageFeedbackOpen, setMessageFeedbackOpen] = useState(false);
  const [feedback, setFeedback] = useState(
    message?.feedbackType === 1 ? 'like' : message?.feedbackType === 2 ? 'dislike' : '',
  );

  const pathname = usePathname();
  const isPredx = pathname.startsWith('/predic/c/');

  async function handleLike(feedback: string) {
    if (!message?.messageId || loading) return false;
    try {
      setLoading(true);
      setFeedback((f) => (!!f ? '' : feedback));
      const res = await customFetch(
        isPredx
          ? `/api/predic/chat/${message.chatId}/message/${message.messageId}`
          : '/api/chat/feedback',
        {
          method: 'POST',
          body: JSON.stringify({
            feedback,
            messageId: message?.messageId,
          }),
        },
      );
      if (res?.error) {
        setFeedback('');
        return false;
      } else {
        setFeedback(feedback);
        return true;
      }
    } finally {
      setLoading(false);
    }
  }

  const handleDislikeClick = async () => {
    const nextFeedback = feedback === 'dislike' ? '' : 'dislike';
    // const updated = await handleLike(nextFeedback);

    // if (updated && nextFeedback === 'dislike') {
    //   setMessageFeedbackOpen(true);
    // }
    handleLike(nextFeedback);
    if (nextFeedback === 'dislike') {
      setMessageFeedbackOpen(true);
    }
  };

  return (
    <>
      <div className="flex flex-row items-center gap-2">
        <button
          onClick={() => handleLike(feedback === 'like' ? '' : 'like')}
          className="text-black/70 dark:text-text-tertiary szie-8 rounded-full flex items-center justify-center hover:bg-[#E9E9E9] dark:hover:bg-[#1e1e1e] transition duration-200 hover:text-black dark:hover:text-white"
        >
          {feedback === 'like' ? <LikedIcon /> : <LikeIcon />}
        </button>
        <button
          onClick={handleDislikeClick}
          className="text-black/70 dark:text-text-tertiary szie-8 rounded-full flex items-center justify-center hover:bg-[#E9E9E9] dark:hover:bg-[#1e1e1e] transition duration-200 hover:text-black dark:hover:text-white"
        >
          {feedback === 'dislike' ? <UnlikedIcon /> : <UnlikeIcon />}
        </button>
      </div>

      <MessageFeedbackDialog
        isOpen={messageFeedbackOpen}
        defaultEmail={userInfo?.email ?? ''}
        conversationContext={{
          chatId: message.chatId,
          messageId: message.messageId,
          parentMessageId: message.parentMessageId,
          role: message.role,
          // content: message.content,
        }}
        onClose={() => setMessageFeedbackOpen(false)}
      />
    </>
  );
};

export default Like;
